import React from 'react';
import '../styles/sections/heroSection.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const HeroSection = (props) => {
    const data = props.data;

    return (
        <div className="heroSection">
            <div className="innerBox lg">
                <div className="contentSection">
                    <h1 className="heroHeading">{data.title}</h1>
                    <div className="heroHeadline" dangerouslySetInnerHTML={{ __html: data.subtext }} />
                </div>
                {data.image && 
                    <div className="imageContainer">
                        <LazyLoadImage
                            alt={data.title}
                            className={` ${data.class} ${data.mobileImage ? 'desktop-only' : '' }`}
                            effect="blur"
                            src={data.image} 
                            />
                        {data.mobileImage && 
                            <LazyLoadImage
                                alt={data.title}
                                className={`mobile-only ${data.class}`}
                                effect="blur"
                                src={data.mobileImage} 
                            />
                        }
                    </div>
                }                
            </div>
        </div>
    )
}

export default HeroSection;